import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private apiUrl = environment.apiUrl;
  constructor(private httpClient: HttpClient) {}

  setPaymentMethod(method: string): Observable<any> {
    const data = {
      method: method
    }
    return this.httpClient.post<any>(`${this.apiUrl}client/paymentMethod`, data)
  }
  getClientBills(id): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.httpClient.get<any>(`${this.apiUrl}client/${id}/bills`).subscribe(items => {
        const billList = [];
        items.forEach(res => {
          const bills: any = res;
          billList.push(bills);
        })
        resolve(billList);
      }, reject);
    });
  }

  getTotalsByClient(id: any): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}invoices/totals/${id}`);
  }

  generateCheckoutLink(element: any): Promise<any> { 
    return new Promise((resolve, reject) => {
      this.httpClient
        .post<any>(`${this.apiUrl}subscription/generateLink`, element)
        .subscribe((res) => {
          resolve(res);
          }, reject);
    });
  }

  /**
   * Sube un documento del cliente al servidor
   */
  uploadDocument(formData: FormData): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl}clients/upload-document`, formData);
  }

  /**
   * Obtiene los documentos del cliente
   */
  getClientDocuments(clientId: number, documentType?: string): Observable<any> {
    let url = `${this.apiUrl}clients/${clientId}/documents`;
    if (documentType) {
      url += `?document_type=${documentType}`;
    }
    return this.httpClient.get<any>(url);
  }

}
